import cn from 'classnames';
import { useContext, useMemo } from 'react';

import Heading from 'components/common/Heading';
import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';
import SocialMediaIconLinks from 'components/signUpFunnel/SocialMediaIconLinks';
import { BrandContext } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';
import styles from 'styles/components/signUpFunnel/thankYou/ShareInvitations';

import CopyInvitationLink from './CopyInvitationLink';
import InviteForm from './InviteForm';
import { default as SmartphoneShareInvitations } from './smartphone/ShareInvitations';

const ShareInvitations = ({ isSmartphoneScreenSize = false }) => {
  const { user } = useContext(UserContext);
  const { brand } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);

  const inviteCode = useMemo(() => {
    return user?.prettyInviteCode || user?.inviteCode;
  }, [user]);

  const referralAmountFormatted = useMemo(() => {
    return user?.referralAmountFormatted;
  }, [user]);

  const invitationLink = useMemo(() => {
    return isTempo
      ? `https://www.tempomeals.com/invite/${inviteCode}`
      : `https://www.homechef.com/invite/${inviteCode}`;
  }, [inviteCode, isTempo]);

  const inviteDescription = `Gift your friends ${user.referralReceiverValue} and earn ${referralAmountFormatted} when they sign up.`;

  const shareSheetText = `Fresh ingredients and chef-designed recipes - try ${
    brandData(brand).displayName
  } and receive up to ${user.referralReceiverValue}.`;

  const DefaultShareInvitations = () => {
    return (
      <div className="flex flex-col items-center pb-32 pt-8 bp1:pb-8">
        <Heading brandStylesOverrides="h3" className="w-[342px] text-left">
          Refer. Earn. Repeat.
        </Heading>
        <Text brandStylesOverrides="textSm" className={styles.inviteDescription}>
          {inviteDescription}
        </Text>
        <InviteForm brand={brand} />
        {inviteCode && (
          <>
            <Text brandStylesOverrides="h7" className={cn(styles.separator, 'my-6')}>
              Or share your invite link
            </Text>
            <CopyInvitationLink invitationLink={invitationLink} brand={brand} />
          </>
        )}

        <SocialMediaIconLinks />
      </div>
    );
  };

  return isSmartphoneScreenSize ? (
    <SmartphoneShareInvitations
      brand={brand}
      invitationLink={invitationLink}
      inviteDescription={inviteDescription}
      shareSheetText={shareSheetText}
    />
  ) : (
    <DefaultShareInvitations />
  );
};

ShareInvitations.propTypes = {
  isSmartphoneScreenSize: PropTypes.bool,
};

export default ShareInvitations;
